import type { DeviceCategory, DeviceStatus } from '@/types'

export type CategoryMeta = {
    label: string
    plural: string
    zone: string
    color: string
    description: string
}

export type StatusMeta = {
    label: string
    color: string
    severity: number
}

export const CATEGORY_ORDER: DeviceCategory[] = ['server', 'network', 'storage']

export const CATEGORY_META: Record<DeviceCategory, CategoryMeta> = {
    server: {
        label: 'Server',
        plural: 'Servers',
        zone: 'Compute',
        color: '#22d3ee',
        description: 'Rack servers, GPU nodes and blade enclosures'
    },
    network: {
        label: 'Network',
        plural: 'Network',
        zone: 'Network',
        color: '#a78bfa',
        description: 'Switches, routers, firewalls and patch fields'
    },
    storage: {
        label: 'Storage',
        plural: 'Storage',
        zone: 'Storage',
        color: '#fb923c',
        description: 'Flash arrays, disk shelves, SAN fabric and archive'
    }
}

export const STATUS_ORDER: DeviceStatus[] = ['online', 'warning', 'critical', 'maintenance', 'offline', 'unknown']

export const STATUS_META: Record<DeviceStatus, StatusMeta> = {
    online: { label: 'Online', color: '#34d399', severity: 0 },
    maintenance: { label: 'Maintenance', color: '#60a5fa', severity: 1 },
    offline: { label: 'Offline', color: '#64748b', severity: 1 },
    warning: { label: 'Warning', color: '#facc15', severity: 2 },
    critical: { label: 'Critical', color: '#f43f5e', severity: 3 },
    unknown: { label: 'Unknown', color: '#94a3b8', severity: 0 }
}

// Temperature scale used by the thermal lens, the legend and the device panel.
export const THERMAL_STOPS: { temp: number, color: string }[] = [
    { temp: 18, color: '#3b82f6' },
    { temp: 22, color: '#22d3ee' },
    { temp: 25, color: '#34d399' },
    { temp: 27.5, color: '#facc15' },
    { temp: 30, color: '#fb923c' },
    { temp: 33, color: '#ef4444' }
]
